/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo, useRef } from "react";
import { NIL as NIL_UUID } from "uuid";
import { ButtonHLPure, DialogSystemGLPure, ClassificationPanelPure } from "../../pures";
import "./signature-request-categories.css";

const SignatureRequestCategoriesView = (props) => {
    const {
        t,

        companies,
        getCategories,
        subCategories,
        typeDocuments,
        selectedStep,
        step,
        stepMetadata,

        categoryIdSelected,
        subCategoryIdSelected,

        setDigitalVaultCategory,

        selectedQuestionnaire,
        createSubcategory,
        refreshCategories,
        permission
    } = props;

    const stepData = stepMetadata[selectedStep]
    const { next: changeCategories } = stepData
    const { back: backLabel, next: nextLabel } = step

    // const categoryService = new CategoryService(process.env.REACT_APP_MIFIRMA_API)

    const [infoType, setInfoType] = useState(1)

    // --- Estados principales
    const [select, setSelect] = useState([""]);
    const [companyId, setCompanyId] = useState(NIL_UUID);
    const [categoryId, setCategoryId] = useState(0);
    const [typeDocument, setTypeDocument] = useState("");
    const [expandedNodes, setExpandedNodes] = useState([]);
    const [showErrorCompany, setShowErrorCompany] = useState(false);
    const [showErrorTypeDoc, setShowTypeDoc] = useState(false);
    const [companyDisable, setCompanyDisable] = useState(true);

    // --- Estados de diálogo de subcategorías
    const [showCategoryDialog, setShowCategoryDialog] = useState(false);
    const [categoryName, setCategoryName] = useState("");
    const [categoryNameError, setCategoryNameError] = useState(false);
    const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(0);

    // --- Estados de carga y notificación
    const [isLoading, setIsLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [textError, setTextError] = useState("");

    const canCreateSubcategory = useMemo(() => {
        if (!permission || !permission.subcategory) {
            return false
        }

        return permission.subcategory.create === true
    }, [permission])


    const initializedRef = useRef(false)
    useEffect(() => {
        if (typeDocuments && typeDocuments.length > 0) {
            const key = typeDocuments[0]?.infoType
            if (key === process.env.REACT_APP_DIGITAL_VAULT_EXPEDIENTE) return setInfoType(2)
            if (key === process.env.REACT_APP_DIGITAL_VAULT_DOCUMENT) return setInfoType(1)
        }

        const hasPSC = !!(props.serviceCMChecked || props.serviceSTChecked)
        const hasProofOfLife = !!props.proofOfLifeChecked
        const isPackageOrVolume = !!(props.signgRequestIsPackage || props.isByVolume || (props.profilesDocuments && props.profilesDocuments.length > 1))
        setInfoType((hasPSC || hasProofOfLife || isPackageOrVolume) ? 2 : 1)
    }, [typeDocuments, props.serviceCMChecked, props.serviceSTChecked, props.proofOfLifeChecked, props.signgRequestIsPackage, props.isByVolume, props.profilesDocuments])

    // Inicializa datos base
    useEffect(() => {
        const disabled =
            selectedQuestionnaire &&
            selectedQuestionnaire.classifier &&
            selectedQuestionnaire.classifier.companyId &&
            selectedQuestionnaire.classifier.companyId !== NIL_UUID;

        setCompanyDisable(disabled);
        setDigitalVaultCategory(
            setCompanyId,
            setTypeDocument,
            setCategoryId,
            setSelect,
            () => { }
        );
    }, []);

    // restaurar selección visual en el árbol y sincronizar ids locales
    useEffect(() => {
        if (subCategories && subCategories.length > 0) {
            let expanded = [];
            let selectedIndex = "";

            if (subCategoryIdSelected && subCategoryIdSelected > 0) {
                expanded.push(String(categoryIdSelected));
                expanded.push(String(subCategoryIdSelected));

                selectedIndex = String(subCategoryIdSelected)

                setSelectedSubCategoryId(subCategoryIdSelected)
                setCategoryId(categoryIdSelected)
            }
            else if (categoryIdSelected && categoryIdSelected > 0) {
                expanded.push(String(categoryIdSelected));
                selectedIndex = String(categoryIdSelected)

                setSelectedSubCategoryId(categoryIdSelected)
                setCategoryId(categoryIdSelected)
            }

            setExpandedNodes(expanded);
            setSelect([selectedIndex]);
        }
    }, [subCategories, categoryIdSelected, subCategoryIdSelected]);

    // Manejador de cambios
    const handleChange = (e, setValue, type, setShowError, typeSelect) => {
        let value = (typeSelect === 'typeDocument') ? e.value : e.target.value
        if (type === "Number") value = Number(value);
        if (setShowError) setShowError(false);
        setValue(value);

        if (typeSelect === "company") {
            getCategories(value, setCategoryId, setSelect);
        }
    };

    //  Selección del árbol (IGUAL que questionnaires)
    const onChangeTree = (args) => {
        const selectedNode = args.nodeData || args.data;
        if (!selectedNode) return;

        const nodeId = selectedNode.id;
        const parentId = selectedNode.parentID || selectedNode.parentId || 0;

        // Para que aparezca el botón "+ Agregar subcategoría":
        // - Si el nodo seleccionado es una categoría (parentId = 0), entonces categoryId debe ser el id del nodo.
        // - Si el nodo seleccionado es una subcategoría, entonces categoryId debe ser su parentId.
        const containerCategoryId = (!parentId || Number(parentId) === 0) ? nodeId : parentId;
        setCategoryId(containerCategoryId);
        // Guardamos el nodo seleccionado para usarlo como referencia de creación
        setSelectedSubCategoryId(nodeId);

        setSelect([String(nodeId)])
    };


    // Crear nueva subcategoría (EXACTAMENTE igual que questionnaires)
    const handleAddSubcategory = () => setShowCategoryDialog(true);

    const handleCreateSubcategory = async () => {
        if (!categoryName.trim()) {
            setCategoryNameError(true);
            return;
        }

        setCategoryNameError(false);

        // 1. PRIMERO cerrar el diálogo
        setShowCategoryDialog(false);
        setCategoryName('');

        // 2. LUEGO mostrar loading
        setIsLoading(true);

        try {
            // Usar selectedSubCategoryId como padre (igual que questionnaires)
            const parentId = selectedSubCategoryId > 0 ? selectedSubCategoryId : null;

            const response = await createSubcategory({
                categoryName: categoryName.trim(),
                companyId,
                parentId
            });

            if (response && response.id) {
                // Refrescar el árbol IGUAL que questionnaires
                await refreshCategories(companyId);

                // Mostrar success y ocultar después de 2 segundos
                setIsLoading(false);
                setSuccess(true);
                setTimeout(() => setSuccess(false), 2000);
            } else {
                throw new Error("Error al crear subcategoría");
            }
        } catch (err) {
            console.error(err);
            setIsLoading(false);
            setError(true);
            setTextError(err.message || 'Error al crear subcategoría');
            setTimeout(() => setError(false), 3000);
        }
    };

    // Buscar nodo por id
    const findNodeById = (nodes = [], id) => {
        return nodes.find((node) => Number(node.id) === Number(id)) || null;
    };

    // Validar formulario antes de continuar
    const validateForm = () => {
        let isValid = true;

        // Validar empresa (campo obligatorio)
        if (!companyId || companyId === NIL_UUID) {
            setShowErrorCompany(true);
            isValid = false;
        }

        return isValid;
    };

    // Avanzar / regresar de paso
    const handleChangeCategories = (changePage) => {
        // Validar antes de continuar (solo para avanzar - changePage = 2)
        if (changePage === 2 && !validateForm()) {
            return; // Detener la ejecución si la validación falla
        }

        let pathBreadcrumb = "";
        let subCategoryId = 0;
        let categoryNameSelected = "";
        let subCategoryNameSelected = "";

        if (companyId && companyId !== NIL_UUID && categoryId && categoryId > 0) {
            const categoryNode = findNodeById(subCategories, categoryId);
            const subCategoryNode = findNodeById(subCategories, selectedSubCategoryId);

            const nodeParentId = subCategoryNode ? Number(subCategoryNode.parentID ?? subCategoryNode.parentId ?? 0) : 0;

            if (subCategoryNode && nodeParentId > 0) {
                subCategoryNameSelected = subCategoryNode.name || "";

                const parentNode = findNodeById(subCategories, nodeParentId);
                if (parentNode) {
                    categoryNameSelected = parentNode.name || ""
                } else if (categoryNode) {
                    categoryNameSelected = categoryNode.name || ""
                }

                subCategoryId = subCategoryNode.id;
                pathBreadcrumb = `${nodeParentId}/${subCategoryNode.id}`;
            } else if (categoryNode) {
                categoryNameSelected = categoryNode.name || "";
                subCategoryId = 0;
                pathBreadcrumb = `${categoryNode.id}`;
            }
        }

        const data = {
            companyIdSelected: companyId,
            categoryIdSelected: categoryId,
            subCategoryIdSelected: subCategoryId,
            pathBreadcrumbSelected: pathBreadcrumb,
            typeDocumentSelected: typeDocument,
            categoryNameSelected,
            subCategoryNameSelected,
        };

        changeCategories(data, changePage);
    };

    return (
        <div className="signatureRequestCategoriesView-container">
            <div className="signatureRequestCategoriesView-elements">
                <div className="signatureRequestCategoriesView-inputs">
                    <div className="signatureRequestCategoriesView-subtitle">
                        <p className="signatureRequestCategoriesView-label-title">
                            {t("signatureRequestProfile.digitalVault.assignCategory")}
                        </p>
                    </div>

                    <ClassificationPanelPure
                        companies={companies}
                        companyId={companyId}
                        onCompanyChange={(e) =>
                            handleChange(e, setCompanyId, null, setShowErrorCompany, "company")
                        }
                        companyDisabled={companyDisable}
                        showCompanyError={showErrorCompany}
                        companyErrorMessage={t("questionnairesAssignCategories.company.error")}
                        categoriesData={subCategories}
                        categoryId={selectedSubCategoryId}
                        onTreeNodeClick={onChangeTree}
                        expandedNodes={expandedNodes}
                        selectedNodes={select}
                        onAddSubcategory={handleAddSubcategory}
                        showAddSubcategoryButton={companyId && companyId !== NIL_UUID && categoryId > 0}
                        canCreateSubcategory={canCreateSubcategory}
                        usePanelBar={true}
                        infoType={infoType}
                        showCategoryDialog={showCategoryDialog}
                        onCloseCategoryDialog={() => setShowCategoryDialog(false)}
                        onSubmitCategory={handleCreateSubcategory}
                        categoryName={categoryName}
                        onCategoryNameChange={setCategoryName}
                        categoryNameError={categoryNameError}
                        dialogType="subcategory"
                        typeDocuments={typeDocuments}
                        selectedTypeDocument={typeDocument}
                        onTypeDocumentChange={(e) =>
                            handleChange(e, setTypeDocument, null, setShowTypeDoc, 'typeDocument')
                        }
                        showTypeDocError={showErrorTypeDoc}
                        typeDocErrorMessage={t(
                            "questionnairesAssignCategories.error.type.document"
                        )}
                        requireCompany={true}
                    />
                </div>

                <div className="signatureRequestCategoriesView-btns">
                    <div className="signatureRequestCategoriesView-btn-back">
                        <ButtonHLPure
                            nameBtn={backLabel}
                            primary={false}
                            onClickBtn={() => handleChangeCategories(1)}
                        />
                    </div>

                    <ButtonHLPure
                        nameBtn={nextLabel}
                        primary={true}
                        onClickBtn={() => handleChangeCategories(2)}
                    />
                </div>
            </div>

            <DialogSystemGLPure
                showLoadingRequesting={isLoading}
                toggleLoadingRequesting={() => setIsLoading((prev) => !prev)}
                showCompletedRequesting={success}
                toggleCompletedRequesting={() => setSuccess((prev) => !prev)}
                showErrorRequesting={error}
                toggleErrorRequesting={() => setError((prev) => !prev)}
                messageError={textError}
            />
        </div >
    )
}

export default SignatureRequestCategoriesView